import type { FindexUser } from "@/types/models/user";
import { parseDate } from "../formatting/date";
import * as fns from 'date-fns';

export const getUserFullName = (user: FindexUser | { firstname?: string; lastname?: string; email?: string; }) => {
  if (!user) return 'No Name';
  if (user.firstname && user.lastname) return `${user.firstname} ${user.lastname}`;

  const firstnames: string[] = [];
  const lastnames: string[] = [];

  if (user.firstname) firstnames.push(user.firstname);
  if (user.lastname) lastnames.push(user.lastname);

  if (user.email && user.email.includes('@')) {
    const left = user.email.split('@')[0];
    if (left && left.includes('.')) {
      const [a, b] = left.split('.');
      if (a) {
        firstnames.push(a);
      }
      if (b) {
        lastnames.push(b);
      }
    }
  }

  const firstname = firstnames.find(it => !!it);
  const lastname = lastnames.find(it => !!it);

  if (firstname && lastname) return `${firstname} ${lastname}`;
  if (firstname) return firstname;
  if (lastname) return lastname;
  if (user.email) return user.email;

  return 'No Name';
}

export const getUserInitials = (user: FindexUser): string[] => {
  const name = getUserFullName(user);
  if (name.length <= 0) return [];
  if (name.includes(' ')) {
    const [a, b] = name.split(' ');
    return [
      a[0].toUpperCase(),
      b[0].toUpperCase()
    ]
  }
  return [name[0].toUpperCase()];
}

export const getUserLastOnlineDate = (user: FindexUser): Date | undefined => {
  const dates = [user.lastOnline, user.lastActivity, (user as any).createdAt].filter(it => !!it).map(it => parseDate(it));
  if (dates.length <= 0) return undefined;
  return dates.find(it => !!it);
}

export const getUserLastOnlineDateFormated = (user: FindexUser): string => {
  const date = getUserLastOnlineDate(user);
  if (!date) return 'never';
  return fns.formatDistanceToNow(date, {addSuffix: true});
}
